export interface LoginTranslations {
  title: string;
  email: {
    label: string;
    placeholder: string;
  },
  continueButton: {
    text: string;
  },
  registerByPin: {
    text: string;
  },
  version: string;
  loggingIn: string;
  finishingLogin: string;
}

export const loginTranslationKeys: LoginTranslations = {
  title: 'title',
  email: {
    label: 'email.label',
    placeholder: 'email.placeholder',
  },
  continueButton: {
    text: 'continueButton.text',
  },
  registerByPin: {
    text: 'registerByPin.text',
  },
  version: 'version',
  loggingIn: 'loggingIn',
  finishingLogin: 'finishingLogin',
};

export const loginTranslationsEN: LoginTranslations = {
  title: 'Sign In',
  email: {
    label: 'Login Email',
    placeholder: 'Enter your registered login email...',
  },
  continueButton: {
    text: 'Continue',
  },
  registerByPin: {
    text: 'Register by PIN',
  },
  version: 'Version:',
  loggingIn: 'Redirecting to Login...',
  finishingLogin: 'Finishing Login...',
};

export const loginTranslationsES: LoginTranslations = {
  title: 'Iniciar sesión',
  email: {
    label: 'Correo electrónico',
    placeholder: 'Introduce tu correo electrónico registrado...',
  },
  continueButton: {
    text: 'Continuar',
  },
  registerByPin: {
    text: 'Registrarse por PIN',
  },
  version: 'Versión:',
  loggingIn: 'Redirigiendo al inicio de sesión...',
  finishingLogin: 'Finalizando inicio de sesión...',
};
